import React from 'react';
import {
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  ModalBody,
} from 'reactstrap';
import TipsComponent from '@componentes/tips/tips.component';
import CheckBox from '@componentes/checkbox/checkbox.component';
import ConfirmarCancelamento from '@componentes/cancelamento/confirmacao.component';
import IntlMessage from '../../../../../../helpers/intlMessage';
import { injectIntl } from 'react-intl';

const CancelamentoPage = (props) => {

  const {messages} = props.intl;
  return(
  <div>
    <ConfirmarCancelamento
      isOpen={props.showModal}
      toggle={props.toggleModalConfirmarCancelamento}
      shoModalJustificativa={props.toggleModalCancelamento}
    />
    <div className="cancelamento-container">
      <Modal
        size="lg"
        isOpen={props.showModalCancelamento}
        toggle={props.toggleModalCancelamento}
      >
        <ModalHeader toggle={props.toggleModalCancelamento}>
          <IntlMessage id = "dashboards.examDetail.stepCancellation"/>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <FormGroup className="justificativa-cancelar">
                <Label><IntlMessage id = "dashboards.examDetail.justificationCancellation"/></Label>
                <Input
                  type="textarea"
                  name="text"
                  placeholder={messages["dashboards.examDetail.justificationForReopening"]}
                  onChange={(e) => {
                    props.setJustificativa(e.target.value);
                  }}
                  value={props.justificativa}
                />
              </FormGroup>
            </Col>
          </Row>
          {props.existeBlocoAndLamina && (
            <Row>
              <Col>
                <CheckBox
                  label={props.labelChekboxCancelarBlocoAndLaminas}
                  onChange={props.onChangeCheckboxCancelarBlocosAndLaminas}
                  checked={props.cancelarBlocoAndLaminas}
                ></CheckBox>
              </Col>
            </Row>
          )}
          <Row>
            {props.blocosExistentes.length > 0 && (
              <Col>
                <ul className="listagem-blocos-laminas-cancelamento">
                  {props.blocosExistentes.map((el) => (
                    <li>
                      <i className="fas fa-cubes"></i> {el}
                    </li>
                  ))}
                </ul>
              </Col>
            )}
            {props.laminasExistentes.length > 0 && (
              <Col>
                <ul className="listagem-blocos-laminas-cancelamento">
                  {props.laminasExistentes.map((el) => (
                    <li>
                      <i className="fas fa-square-full"></i> {el}
                    </li>
                  ))}
                </ul>
              </Col>
            )}
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button onClick={props.toggleModalCancelamento} color="secondary">
            <IntlMessage id = "dashboards.examDetail.comeBack"/>
          </Button>
          <Button
            onClick={props.cancelarEtapasPosteriores}
            disabled={
              !props.justificativa ||
              (props.existeBlocoAndLamina && !props.cancelarBlocoAndLaminas)
            }
            color="primary"
          >
            <IntlMessage id = "dashboards.examDetail.cancelStep"/>
          </Button>
        </ModalFooter>
      </Modal>
      <p className="title"><IntlMessage id = "dashboards.examDetail.cancellation"/></p>
      {!props.disableCancelamento && (
        <Row>
          <Col>
            <TipsComponent color="danger">
              <IntlMessage id = "dashboards.examDetail.cancelingAllowed"/>
            </TipsComponent>
          </Col>
        </Row>
      )}
      {props.disableCancelamento && (
        <Row>
          <Col>
            <Button
              onClick={props.showModalConfirmarCancelamento}
              color="danger"
              disabled={props.disableButton}
            >
              <IntlMessage id = "dashboards.examDetail.confirmCancellation"/>
            </Button>
          </Col>
        </Row>
      )}
    </div>
  </div>
);
}

export default injectIntl(CancelamentoPage);



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/material/tabs/cancelamento/cancelamento.page.js